import { Component, OnInit, Input, Inject } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DriveLevel, MasterTemplateCategory } from '../Enum/common.enum';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-importMyDrive',
  templateUrl: './importMyDrive.component.html',
  styleUrls: ['./importMyDrive.component.scss']
})

export class ImportMyDriveListComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;

  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;
  menuHeaderMyDrive: any = [] = [];
  menuHeader: any = [] = [];

  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);

  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  parentID: number = 0;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  SharedWithMeMyDriveactive: boolean = false;

  TypeId: number = 0;

  MyDrivefoldersList: any;
  activeNodeFileManager: string = "";
  FileManagerFolderListLeft: any;
  fileManagerID: string = "";
  foldersMyDriveListShow: boolean = false;
  selectButtonMyDriveShow: boolean = false;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerOffice = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);

  treeControlOffice = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerOffice = new MatTreeFlattener(this._transformerOffice, node => node.level, node => node.expandable, node => node.children);
  dataSourceOffice = new MatTreeFlatDataSource(this.treeControlOffice, this.treeFlattenerOffice);

  // The two libraries carry the same node shape as the drives, so they reuse
  // the File Manager transformer and only need their own tree state.
  treeControlGlobalLibrary = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerGlobalLibrary = new MatTreeFlattener(this._transformerOffice, node => node.level, node => node.expandable, node => node.children);
  dataSourceGlobalLibrary = new MatTreeFlatDataSource(this.treeControlGlobalLibrary, this.treeFlattenerGlobalLibrary);

  treeControlOfficeLibrary = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerOfficeLibrary = new MatTreeFlattener(this._transformerOffice, node => node.level, node => node.expandable, node => node.children);
  dataSourceOfficeLibrary = new MatTreeFlatDataSource(this.treeControlOfficeLibrary, this.treeFlattenerOfficeLibrary);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  //dialogRef: MatDialogRef<any, any>;

  constructor(public dialogRef: MatDialogRef<ImportMyDriveListComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private settingsService: SettingService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  // Summary
  // Which left-nav sections are expanded. Each entry is toggled by its own
  // header, so the four behave independently: first click expands and loads,
  // second collapses without touching what is already on the right.
  expandedSections: { [section: string]: boolean } = { 'My Drive': true };

  // Summary
  // The section being browsed, as the Level the upload endpoint expects. The
  // left nav is the only thing that sets `textTitle`, so it is the one source
  // for where an uploaded file should land.
  get currentDriveLevel(): number {
    if (this.textTitle == 'Office Drive') {
      return DriveLevel.OfficeDrive;
    }
    if (this.textTitle == 'Global Library') {
      return DriveLevel.GlobalLibrary;
    }
    if (this.textTitle == 'Office Library') {
      return DriveLevel.OfficeLibrary;
    }
    return DriveLevel.MyDrive;
  }

  /** Upload is offered for the drives only; the libraries are read-only here. */
  get canUploadHere(): boolean {
    return this.textTitle != 'Global Library' && this.textTitle != 'Office Library';
  }

  isSectionExpanded(section: string): boolean {
    return this.expandedSections[section] === true;
  }

  // Summary
  // Expand or collapse one section. Expanding loads it, so the tree is never
  // shown empty; collapsing only hides the tree, leaving the pane beside it as
  // the user left it.
  toggleSection(section: string): void {
    const willExpand = !this.isSectionExpanded(section);
    this.expandedSections[section] = willExpand;

    if (!willExpand) {
      return;
    }

    if (section == 'Office Drive') {
      this.GetAllOfficeDrive();
    } else if (section == 'My Drive') {
      this.GetAllMyDrive();
    } else if (section == 'Global Library') {
      this.GetAllGlobalLibrary();
    } else if (section == 'Office Library') {
      this.GetAllOfficeLibrary();
    }
  }

  ngOnInit(): void {
    // The dialog is opened without a width by every caller, so the size is set
    // here instead. The panel class carries the responsive rules.
    this.dialogRef.addPanelClass('mydrive-dialog');

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }


    this.parentID = 0;
    this.activeNodeFileManager = "";
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();


  }

  getFileManagerFolderList() {
    var reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.settingsService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          if (this.FileManagerFolderListLeft != null && this.FileManagerFolderListLeft != undefined) {
            this.dataSourceFileManager.data = this.FileManagerFolderListLeft;
          }
        }
        else {
        }
      }
      else {
      }
    });

  }

  getFileManagerFoldersList(folderId: any) {
    var reqModel = {
      fileManagerItemID: folderId,
      name: "",
      pageIndex: 0,
      pageSize: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.settingsService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if (this.hierarchyList == null || this.hierarchyList == null) {
          this.menuHeaderMyDrive = [];
        } else {
          this.menuHeaderMyDrive = [];
          this.hierarchyList.forEach(e => {
            this.menuHeaderMyDrive.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
          });
        }

        this.MyDrivefoldersList.forEach(e => {
          e.isChecked = false;
        });
        if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
          this.MyDrivefoldersList = [];
          this.foldersMyDriveListShow = true;
        } else {
          this.foldersMyDriveListShow = false;
        }
      }
    });
  }

  closeAll() {
    // this.dialog.closeAll();
    this.dialogRef.close();
  }

  textTitle: string = "My Drive";

  GetAllMyDrive() {
    this.textTitle = "My Drive";
    this.resetDriveView();
    this.dataSourceFileManager.data = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }

  GetAllOfficeDrive() {
    this.textTitle = "Office Drive";
    this.resetDriveView();
    this.dataSourceFileManager.data = [];
    this.getOfficeFoldersListMiddle();
  }

  FileManagerOfficeFolderList: any = [] = [];

  getOfficeFoldersListMiddle() {
    var reqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.settingsService.getOfficeFolders(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerOfficeFolderList = this.responseHolder.data;
          this.MyDrivefoldersList = this.responseHolder.data;
          if (this.FileManagerOfficeFolderList != null && this.FileManagerOfficeFolderList != undefined) {
            this.dataSourceOffice.data = this.FileManagerOfficeFolderList;
          }
          if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
            this.MyDrivefoldersList = [];
            this.foldersMyDriveListShow = true;
          } else {
            this.foldersMyDriveListShow = false;
          }
        } else {
          this.MyDrivefoldersList = [];
          this.loaderService.hide();
        }
      } else {
        this.MyDrivefoldersList = [];
        this.loaderService.hide();
      }
    });

  }

  FileManagerGlobalLibraryList: any = [] = [];
  FileManagerOfficeLibraryList: any = [] = [];

  // Summary
  // Global Library, from FileManager/GetGlobalContent. Same two-pane behaviour
  // as Office Drive: the response fills the left tree and the middle list, and
  // drilling into a folder goes through showChildFolders like everything else.
  GetAllGlobalLibrary() {
    this.textTitle = "Global Library";
    this.resetDriveView();
    this.getGlobalLibraryListMiddle();
  }

  GetAllOfficeLibrary() {
    this.textTitle = "Office Library";
    this.resetDriveView();
    this.getOfficeLibraryListMiddle();
  }

  // Summary
  // The state every left-nav entry resets before loading its own content.
  // Lifted out of GetAllMyDrive / GetAllOfficeDrive rather than copied again.
  private resetDriveView() {
    this.activeNodeFileManager = "";
    this.parentID = 0;
    this.selectButtonMyDriveShow = false;
    this.isShowMyDrive = true;
    this.isShowForm = false;
    this.isSharedWithMe = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
  }

  getGlobalLibraryListMiddle(parentID: any = 0) {
    // GetGlobalContent takes the parent only -- the library is organisation
    // wide, so it carries no user or office context.
    var reqModel = {
      parentID: Number(parentID) || 0,
    }
    this.loaderService.show();
    this.settingsService.getGlobalContent(reqModel).subscribe(response => {
      this.loaderService.hide();
      this.applyLibraryResponse(response, 'global', reqModel.parentID == 0);
    }, () => {
      this.loaderService.hide();
      this.MyDrivefoldersList = [];
      this.foldersMyDriveListShow = true;
    });
  }

  getOfficeLibraryListMiddle(parentID: any = 0) {
    var reqModel = {
      parentID: Number(parentID) || 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.settingsService.getOfficeLibraryContent(reqModel).subscribe(response => {
      this.loaderService.hide();
      this.applyLibraryResponse(response, 'office', reqModel.parentID == 0);
    }, () => {
      this.loaderService.hide();
      this.MyDrivefoldersList = [];
      this.foldersMyDriveListShow = true;
    });
  }

  // Summary
  // Both libraries answer with the same list, so one handler fills the tree it
  // belongs to and the middle pane. Null entries are dropped -- the endpoints
  // are known to return them, as the File Manager left menu also guards.
  private applyLibraryResponse(response: any, which: 'global' | 'office', isRoot: boolean = true) {
    this.MyDrivefoldersList = [];
    this.foldersMyDriveListShow = true;

    if (response == undefined) {
      return;
    }

    this.responseHolder = response;
    if (this.responseHolder.status != this.statusConst.statusSuccess || this.responseHolder.data == null) {
      return;
    }

    var list = this.responseHolder.data.filter(function (el: any) {
      return el != null;
    });

    // Only a root load re-seeds the left tree; opening a folder changes the
    // middle pane alone, as it does for the drives.
    if (isRoot) {
      if (which == 'global') {
        this.FileManagerGlobalLibraryList = list;
        this.dataSourceGlobalLibrary.data = list;
      } else {
        this.FileManagerOfficeLibraryList = list;
        this.dataSourceOfficeLibrary.data = list;
      }
    }

    this.MyDrivefoldersList = list;
    this.foldersMyDriveListShow = list.length == 0;
  }

  // Summary
  // Open one folder. The two libraries have their own content endpoints, so a
  // folder inside them is read with GetGlobalContent / GetOfficeLibraryContent
  // rather than the File Manager hierarchy call the drives use.
  showChildFolders(folder: any, from: any) {
    this.textTitle = from;
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.SharedWithMeMyDriveactive = false;
    this.activeNodeFileManager = folder.fileManagerItemID;
    this.parentID = folder.fileManagerItemID;

    if (from == 'Global Library') {
      this.pushLibraryCrumb(folder);
      this.getGlobalLibraryListMiddle(folder.fileManagerItemID);
      return;
    }

    if (from == 'Office Library') {
      this.pushLibraryCrumb(folder);
      this.getOfficeLibraryListMiddle(folder.fileManagerItemID);
      return;
    }

    this.getFileManagerFoldersList(folder.fileManagerItemID);
  }

  // Summary
  // The library endpoints answer with the folder's contents and no hierarchy,
  // so the breadcrumb is kept here instead. Reopening a folder already on the
  // trail truncates back to it rather than adding a duplicate.
  private pushLibraryCrumb(folder: any) {
    const existing = this.menuHeaderMyDrive
      .map((crumb: any) => crumb.id)
      .indexOf(folder.fileManagerItemID);

    if (existing > -1) {
      this.menuHeaderMyDrive.splice(existing + 1, this.menuHeaderMyDrive.length - existing);
      return;
    }

    this.menuHeaderMyDrive.push({
      label: folder.name,
      id: folder.fileManagerItemID,
      icon: 'navigate_next',
    });
  }


  getSharedWithMeMyDrive() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.settingsService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeMyDriveFolderList = this.responseHolder.data;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.parentID = 0;
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
        else {
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.parentID = 0;
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.SharedWithMeMyDriveFolderList = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }

  breadCrumbMyDriveMainClick() {
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.menuHeaderMyDrive = [];
    this.activeNodeFileManager = "";
    this.parentID = 0;
    this.loadFolder(0);
    //this.getFileManagerFolderList(); 
    this.selectButtonMyDriveShow = false;
    this.foldersMyDriveListShow = false;
  }

  // Summary
  // Read one folder from whichever source is being browsed. The breadcrumb and
  // the tree both come through here, so a library trail keeps calling the
  // library's own endpoint instead of falling back to the drives'.
  private loadFolder(folderID: any) {
    if (this.textTitle == 'Global Library') {
      this.getGlobalLibraryListMiddle(folderID);
    } else if (this.textTitle == 'Office Library') {
      this.getOfficeLibraryListMiddle(folderID);
    } else {
      this.getFileManagerFoldersList(folderID);
    }
  }

  breadCrumbMyDrive(menu: any, index: any) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.loadFolder(data.id);
  }

  radioChangeMyDrive(form: any) {

    if (form.isFile == false) {
      this.MyDrivefoldersList.forEach((e: any) => {
        e.isChecked = false
      });
      this.selectButtonMyDriveShow = false;
      this.showChildFolders(form, this.textTitle);
      return;
    }
    if (form.isFile == true) {
      if (form.fileType != null || form.fileType != "" || form.fileType != undefined) {
        if (form.fileType != "pdf") {
          this.MyDrivefoldersList.forEach((e: any) => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach((e: any) => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          this.PlaceholderName = form.name;
          this.filePath = form.azureblobPath;
          if (form.fileSize) {
            this.fileSizeFromMyDrive = form.fileSize;
          } else {
            this.fileSizeFromMyDrive = "";
          }

          this.MyDrivefoldersList.forEach((e: any) => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });

          this.fileManagerID = form.fileManagerItemID;
        }
      }
      if (form.fileType == null || form.fileType == "" || form.fileType == undefined) {
        var fileName = form.name.split('.').pop();
        if (fileName != "pdf") {
          this.MyDrivefoldersList.forEach((e: any) => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach((e: any) => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          this.PlaceholderName = form.name;
          this.filePath = form.azureblobPath;

          this.MyDrivefoldersList.forEach((e: any) => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });
          this.fileManagerID = form.fileManagerItemID;
        }
      }
    }
  }

  getIsFavorite(isFavorite: any) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  // ===== Shared with me My Drive ======//

  breadCrumbMainSHaredWithMeMyDriveClick() {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive = [];
    this.getSharedWithMeMyDrive();
  }

  breadCrumbSharedWithMeMyDrive(menu: any, index: any) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.showChildFoldersSharedWithMeMyDrive({ type: 1, id: data.id, isFile: data.isFile, name: data.label });
  }

  showChildFoldersSharedWithMeMyDrive(folder: any) {
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.isSharedWithMeMyDrive = true;
    this.SharedWithMeMyDriveactive = true;
    var folderId;
    if (folder.isFile == true) {
      this.menuHeaderMyDrive = [];
    }
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }

    this.menuHeaderMyDrive.push({
      label: folder.name,
      id: folderId,
      icon: 'navigate_next',
      isFile: folder.isFile
    });
    this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing: any, i: any, arr: any) => arr.findIndex((t) => t.id === thing.id) === i);
    this.ChildFoldersSharedWithMeMyDrive(folder);
  }

  ChildFoldersSharedWithMeMyDrive(folder: any) {
    var folderId;
    if (folder.fileManagerItemID == undefined) {
      folderId = folder.id;
    }
    if (folder.fileManagerItemID != undefined) {
      folderId = folder.fileManagerItemID;
    }
    var reqModel = {
      fileManagerItemID: folderId,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.settingsService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.SharedWithMeMyDriveFolderList = response.data;//.children;
        if (this.SharedWithMeMyDriveFolderList != null) {
          this.SharedWithMeMyDriveFolderList.map((res: any) => {
            if (res.sharedbyFirstName != null) {
              res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
            }
            if (res.sharedbyLastName != null) {
              res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
            }
            return res;
          });
        }
        if (this.SharedWithMeMyDriveFolderList == null || this.SharedWithMeMyDriveFolderList.length == 0) {
          this.SharedWithMeMyDriveFolderList = [];
        }
      } else {

      }
    });
  }


  radioChangeMyDriveSharedWithMe(form: any) {
    var folderId;
    if (form.isFile == false) {
      if (form.fileManagerItemID == undefined) {
        folderId = form.id;
      }
      if (form.fileManagerItemID != undefined) {
        folderId = form.fileManagerItemID;
      }
      this.menuHeaderMyDrive.push({
        label: form.name,
        id: folderId,
        icon: 'navigate_next',
        isFile: form.isFile
      });
      this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing: any, i: number, arr: any[]) => arr.findIndex((t: any) => t.id === thing.id) === i);
      this.ChildFoldersSharedWithMeMyDrive(form);
      return;
    }


    if (form.isFile == true) {
      if (form.fileType != "pdf") {
        this.SharedWithMeMyDriveFolderList.forEach((e: any) => {
          e.isChecked = false
        });
        this.toastr.warning('please select only pdf file.', '', {
          timeOut: 3000,
        });
        this.selectButtonMyDriveShow = false;
        return;
      }

      this.selectButtonMyDriveShow = true;
      // this.PlaceholderName = form.name.substring(0, 30);//form.name; //get first 30 chars
      this.PlaceholderName = form.name;//form.name; //get first 30 chars
      this.PlaceholderID = "0";
      if (form.azureblobPath == null || form.azureblobPath == undefined) {
        this.filePath = form.url;
      }
      if (form.url == null || form.url == undefined) {
        this.filePath = form.azureblobPath;
      }
      if (form.fileSize) {
        this.fileSizeFromMyDrive = form.fileSize;
      }
      if (!form.fileSize) {
        this.fileSizeFromMyDrive = "";
      }

      this.SharedWithMeMyDriveFolderList?.forEach((e: any) => {
        e.isChecked = false;
      });

      if (form.fileManagerItemID == undefined) {
        this.fileManagerID = form.id;
        this.SharedWithMeMyDriveFolderList.forEach((e: any) => {
          if (e.id == form.id) {
            e.isChecked = true;
          }
        });
      }
      if (form.fileManagerItemID != undefined) {
        this.fileManagerID = form.fileManagerItemID;
        this.SharedWithMeMyDriveFolderList.forEach((e: any) => {
          if (e.fileManagerItemID == form.fileManagerItemID) {
            e.isChecked = true;
          }
        });
      }
    }

  }



  selectedFile: File | null = null;
  isUploading = false;

  engagingMessages = [
    "Hang tight, we're uploading your file!",
    "Almost there! Your data is on its way.",
    "We’re making progress. Just a bit more patience!",
    "Your file is getting uploaded smoothly.",
    "Crunching data… great things take time!",
    "Uploading… this won’t take long!",
  ];

  showEngagingToaster = (fileName: string) => {
    let messageIndex = 0;
    const toastId = `upload-progress-${fileName}`;

    // Update the engaging message periodically
    const intervalId = setInterval(() => {
      if (messageIndex < this.engagingMessages.length) {
        this.toastr.clear();
        this.toastr.info(this.engagingMessages[messageIndex], '', {
          disableTimeOut: true,
          closeButton: true,
        });
        messageIndex++;
      } else {
        // Loop the messages once all are shown
        messageIndex = 0;
      }
    }, 5000); // Change message every 2 seconds

    return intervalId;
  };

  clearEngagingToaster = (intervalId: any, finalMessage: string) => {
    clearInterval(intervalId); // Stop the interval updates
    this.toastr.clear(); // Clear the previous toast
    this.toastr.success(finalMessage, '', { timeOut: 3000 }); // Show the success message
  };

  fileUploaded: boolean = false;
  parentId: number = 0;

  onFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    this.selectFilesFromDragZone(event, input);
  }

  async selectFilesFromDragZone(event: Event, fileInput: HTMLInputElement): Promise<void> {

    this.loaderService.show();

    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      this.toastr.error('No files selected.', '', { timeOut: 3000 });
      this.loaderService.hide();
      return;
    }

    const chunkSize = 10 * 1024 * 1024;   // 10 MB
    const maxFileSize = 20 * 1024 * 1024; // 20 MB

    const uploadedFiles = Array.from(input.files);
    const invalidCharsRegex = /[ #?%+&:;@="<>\\|^`{}\[\]]/g;

    let uploadSuccess = false;

    const processFile = async (file: File): Promise<void> => {

      // File Size Validation
      if (file.size > maxFileSize) {

        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

        this.toastr.warning(
          `"${file.name}" is ${sizeInMB} MB. Maximum allowed file size is 20 MB.`,
          '',
          { timeOut: 9000 }
        );

        fileInput.value = '';
        return;
      }

      // Password Protected PDF
      if (file.type === 'application/pdf') {

        const isPasswordProtected = await new Promise<boolean>((resolve) => {

          const reader = new FileReader();

          reader.onload = (e: any) => {
            try {
              const uint8Array = new Uint8Array(e.target.result);
              const pdfText = new TextDecoder().decode(uint8Array);
              resolve(pdfText.includes('/Encrypt'));
            } catch {
              resolve(false);
            }
          };

          reader.onerror = () => resolve(false);
          reader.readAsArrayBuffer(file);
        });

        if (isPasswordProtected) {
          this.toastr.warning(
            `"${file.name}" is password protected and cannot be processed.`,
            '',
            { timeOut: 9000 }
          );
          return;
        }
      }

      // File Name Validation
      const originalFileName = file.name;
      const lastDotIndex = originalFileName.lastIndexOf('.');

      if (lastDotIndex === -1) {
        this.toastr.warning(`Invalid file format: "${originalFileName}".`);
        return;
      }

      let nameWithoutExt = originalFileName.substring(0, lastDotIndex);
      const extension = originalFileName.substring(lastDotIndex + 1);

      let cleanedName = nameWithoutExt
        .replace(invalidCharsRegex, '')
        .replace(/\s+/g, '');

      if (!cleanedName) {
        this.toastr.warning('Invalid file name after cleanup.');
        return;
      }

      if (cleanedName.length > 120) {

        this.toastr.warning(
          'File name up to 120 characters only supported.',
          '',
          { timeOut: 6000 }
        );

        fileInput.value = '';
        return;
      }

      const finalFileName = `${cleanedName}.${extension}`;

      const newFile = new File([file], finalFileName, {
        type: file.type
      });

      const totalChunks = Math.ceil(newFile.size / chunkSize);

      let intervalId: any;
      this.fileUploaded = false;

      for (let i = 0; i < totalChunks; i++) {

        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, newFile.size);

        const chunk = newFile.slice(start, end);

        const formData = new FormData();

        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());
        formData.append('fileName', finalFileName);
        formData.append('FileDetailList', `${cleanedName}|${extension}`);

        formData.append('ParentID', this.parentID.toString());
        // Which drive or library the file belongs to; ParentID alone cannot say,
        // since every section numbers its own root 0.
        formData.append('Level', this.currentDriveLevel.toString());
        formData.append('UserID', this.currentUser.UID);
        formData.append('OrganizationID', this.organizationId);
        formData.append('OfficeID', this.myOfficeID);
        formData.append('DatabaseID', this.databaseId);

        try {

          const response = await this.settingsService
            .uploadChunk(formData)
            .toPromise();

          if (response?.data === 2) {

            this.fileUploaded = true;

            this.toastr.warning(
              `${finalFileName} already exists.`,
              '',
              { timeOut: 3000 }
            );

            return;
          }

          this.toastr.clear();

          this.toastr.info(
            `Chunk ${i + 1}/${totalChunks} uploaded`,
            '',
            { timeOut: 1000 }
          );

          // Last chunk uploaded
          if (i === totalChunks - 1) {

            uploadSuccess = true;

            intervalId = this.showEngagingToaster(finalFileName);

            this.clearEngagingToaster(
              intervalId,
              `File ${finalFileName} uploaded successfully!`
            );
            this.getFileManagerFoldersList(this.parentID);
          }

        } catch {

          this.toastr.error(
            `Error uploading ${finalFileName}`,
            '',
            { timeOut: 3000 }
          );

          return;
        }
      }
    };

    try {

      // Upload files one by one
      for (const file of uploadedFiles) {
        await processFile(file);
      }

      fileInput.value = '';
      this.formDialog.reset();

      // Refresh only if upload succeeded
      if (uploadSuccess) {

        // Wait for server to complete merge (if needed)
        // await new Promise(resolve => setTimeout(resolve, 1000));

        // this.getFileManagerFoldersList(this.parentID);

        // If using Shared With Me
        // if (this.isSharedWithMe) {
        //   this.getFileManagerFoldersListSharedWithMe(...);
        // }
      }

    } finally {

      this.loaderService.hide();

    }
  }

  PlaceholderName: string = "";
  filePath: string = "";
  fileSizeFromMyDrive: string = "";
  PlaceholderID: string = "0"

  AddCoreDocumentfromMyDrive() {
    this.PlaceholderName;
    this.fileManagerID;
    this.filePath;
    //var ext =  this.PlaceholderName.split('.').pop();
   // var fileName = this.PlaceholderName.split('.');
   // var filepaths = this.filePath.split('.');

     this.dialogRef.close({
        attachType:1, //0 url,1 File, 2 Video
        url: this.PlaceholderName,
        type: 'Files',
        filePathurl:this.filePath,
        fileManagerID:this.fileManagerID
      });
  }

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}